// src/features/merchant/dashboardThunks.js
import { createAsyncThunk } from '@reduxjs/toolkit';
import merchantApi from '../../api/merchantApi';

// ================= DASHBOARD =================
export const fetchDashboard = createAsyncThunk(
  'dashboard/fetchDashboard',
  async (_, thunkAPI) => {
    try {
      const res = await merchantApi.getDashboardApi();
      return res;
    } catch (err) {
      const message =
        err?.response?.data?.message || err.message || 'Failed to fetch dashboard';
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const updateOverview = createAsyncThunk(
  'dashboard/updateOverview',
  async ({ documentId, payload }, thunkAPI) => {
    try {
      const res = await merchantApi.updateOverviewApi(documentId, payload);
      return res;
    } catch (err) {
      const message =
        err?.response?.data?.message || err.message || 'Failed to update overview';
      return thunkAPI.rejectWithValue(message);
    }
  }
);

// ================= CATALOGUE =================
export const createCatalogueItem = createAsyncThunk(
  'dashboard/createCatalogueItem',
  async (formData, thunkAPI) => {
    try {
      const res = await merchantApi.createCatalogueItemApi(formData);
      return res;
    } catch (err) {
      const message =
        err?.response?.data?.message || err.message || 'Failed to create catalogue item';
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const updateCatalogueItem = createAsyncThunk(
  'dashboard/updateCatalogueItem',
  async ({ id, formData }, thunkAPI) => {
    try {
      const res = await merchantApi.updateCatalogueItemApi(id, formData);
      return res;
    } catch (err) {
      const message =
        err?.response?.data?.message || err.message || 'Failed to update catalogue item';
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const deleteCatalogueItem = createAsyncThunk(
  'dashboard/deleteCatalogueItem',
  async (id, thunkAPI) => {
    try {
      const res = await merchantApi.deleteCatalogueItemApi(id);
      return { id, res };
    } catch (err) {
      const message =
        err?.response?.data?.message || err.message || 'Failed to delete catalogue item';
      return thunkAPI.rejectWithValue(message);
    }
  }
);

// ================= QUICK INFO =================
export const updateQuickInfoText = createAsyncThunk(
  'dashboard/updateQuickInfoText',
  async (payload, thunkAPI) => {
    try {
      const res = await merchantApi.updateQuickInfoTextApi(payload);
      return res;
    } catch (err) {
      return thunkAPI.rejectWithValue(err?.response?.data?.message);
    }
  }
);

export const uploadQuickInfoImages = createAsyncThunk(
  'dashboard/uploadQuickInfoImages',
  async (formData, thunkAPI) => {
    try {
      const res = await merchantApi.uploadQuickInfoImagesApi(formData);
      return res;
    } catch (err) {
      return thunkAPI.rejectWithValue(err?.response?.data?.message);
    }
  }
);

export const deleteQuickInfoImage = createAsyncThunk(
  'dashboard/deleteQuickInfoImage',
  async (id, thunkAPI) => {
    try {
      const res = await merchantApi.deleteQuickInfoImageApi(id);
      return { id, res };
    } catch (err) {
      return thunkAPI.rejectWithValue(err?.response?.data?.message);
    }
  }
);

// ================= BUSINESS KEYWORDS =================
export const fetchKeywords = createAsyncThunk(
  'dashboard/fetchKeywords',
  async (search = '', thunkAPI) => {
    try {
      const res = await merchantApi.fetchKeywordsApi(search);
      return res;
    } catch (err) {
      return thunkAPI.rejectWithValue(err?.response?.data?.message || 'Failed to fetch keywords');
    }
  }
);

export const createKeyword = createAsyncThunk(
  'dashboard/createKeyword',
  async (name, thunkAPI) => {
    try {
      const res = await merchantApi.createKeywordApi(name);
      return res;
    } catch (err) {
      return thunkAPI.rejectWithValue(err?.response?.data?.message || 'Failed to create keyword');
    }
  }
);

export const updateMerchantKeywords = createAsyncThunk(
  'dashboard/updateMerchantKeywords',
  async (keywordIds, thunkAPI) => {
    try {
      const res = await merchantApi.updateMerchantKeywordsApi(keywordIds);
      return res;
    } catch (err) {
      return thunkAPI.rejectWithValue(err?.response?.data?.message || 'Failed to update keywords');
    }
  }
);
